import { useEffect, useState } from 'react';
import styled, { DefaultTheme, withTheme } from 'styled-components';
import { Affix } from 'antd';
import { useMediaQuery } from 'react-responsive';

import { IContact } from '../../common/model/mailchimp/contact.model';

import HighlightedBanner from './highlightedBanner';

type Props = {
  query: string;
  visible: boolean;
  onContactButtonClick: (contact: IContact) => void;
  theme: DefaultTheme;
};

const AffixContainer = styled.div`
  z-index: 90;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  @media ${(props) => props.theme.breakpoints.smd} {
    top: unset;
    bottom: 0;
  }
`;

const StickyHighlightedBanner: React.FC<Props> = ({
  query,
  visible,
  onContactButtonClick,
  theme,
}) => {
  const isSmd = useMediaQuery({ query: theme.breakpoints.smd });

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!visible || !isMounted) {
    return null;
  }

  return (
    <AffixContainer>
      <Affix
        offsetTop={isSmd ? undefined : 0}
        offsetBottom={isSmd ? 0 : undefined}
      >
        <HighlightedBanner
          query={query}
          index={0}
          onContactButtonClick={onContactButtonClick}
          sticky
        />
      </Affix>
    </AffixContainer>
  );
};

export default withTheme(StickyHighlightedBanner);
